import { render, staticRenderFns } from "./DeliveryReturnSlit.vue?vue&type=template&id=21251cb7&scoped=true&"
import script from "./DeliveryReturnSlit.vue?vue&type=script&lang=js&"
export * from "./DeliveryReturnSlit.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryReturnSlit.vue?vue&type=style&index=0&id=21251cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21251cb7",
  null
  
)

export default component.exports